const API_URL = "https://dev.v1.roosterkracht.eu";
export default API_URL;
